
import { Options, Vue } from "vue-class-component";
import CrudRntrcSolicitacao from "../../components/rntrc/CrudRntrcSolicitacao.vue";

@Options({
  props: {
    idRntrcSolicitacao: Number
  },
  components: {
    CrudRntrcSolicitacao
  }
})
export default class RntrcSolicitacao extends Vue {
  idRntrcSolicitacao?: number;
}
